/**
 * Ce que ce front sait afficher, déclaré au backend dans l'en-tête `X-Masteur-Client-Features`
 * (lu par `backend/app/Helpers/ClientFeatures.php` et `FastTrack/Recognition/RecognitionClientSupport.php`).
 *
 * Une app mobile tourne sur son ancien bundle tant que l'OTA ne s'est pas appliquée : elle ne
 * déclare pas les nouveautés, et le backend lui renvoie ce qu'elle sait afficher. C'est donc ici,
 * et seulement ici, qu'on ajoute une capacité quand le backend en dépend.
 *
 * - `enonce-marks` : les marques de rôle des énoncés (consigne, donnée, notion, piège). Sans elle,
 *   le backend envoie l'énoncé sans marques — un ancien bundle les afficherait en partie en double.
 * - `fast-track-recognition` : la réponse « On vous connaît déjà » du fast-track.
 */
export const CLIENT_FEATURES_HEADER = "X-Masteur-Client-Features"

export const CLIENT_FEATURES = ["enonce-marks", "fast-track-recognition"].join(
    ","
)
